/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { CreateAPITokenPage } from '@/pages/APITokens/CreateAPITokenPage';

export function CreateAPITokenRoute() {
  return <CreateAPITokenPage />;
}
